import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle } from 'lucide-react';
import { API } from '../App';
import { useT } from '../i18n';

/*
  On a cheaper plan card: what the workspace uses that this plan does not
  include or does not fit (plan, stage 2). Nothing is shown when nothing is
  lost.
*/

function featureLabel(t, key) {
  switch (key) {
    case 'automation_rules':
      return t('Automation rules');
    case 'custom_metrics':
      return t('Custom metrics');
    case 'conversion_types':
      return t('Conversion types');
    case 'api_keys':
      return t('API keys');
    case 'webhooks':
      return t('Webhooks');
    case 'cost_sync':
      return t('Cost sync');
    case 'domain_pools':
      return t('Domain pools');
    case 'lead_forms':
      return t('Lead forms');
    case 'users':
      return t('Users');
    case 'domains':
      return t('Domains');
    case 'scheduled_reports':
      return t('Scheduled reports');
    case 'public_report_links':
      return t('Public report links');
    default:
      return key;
  }
}

export default function DowngradeImpact({ plan, label }) {
  const { t } = useT();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!plan) return undefined;
    let alive = true;
    axios
      .get(`${API}/billing/downgrade-impact`, { params: { plan } })
      .then((res) => {
        if (alive) setItems(Array.isArray(res.data?.items) ? res.data.items : []);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [plan]);

  if (!items.length) return null;
  return (
    <div className="mb-4 rounded-md border border-amber-500/40 bg-amber-500/10 p-3 text-xs" data-testid={`downgrade-impact-${plan}`}>
      <div className="mb-1 flex items-center gap-1.5 font-medium">
        <AlertTriangle className="h-3.5 w-3.5" />
        {t('If you switch to {plan}:', { plan: label || plan })}
      </div>
      <ul className="space-y-0.5">
        {items.map((i) => (
          <li key={i.key}>
            {i.kind === 'limit'
              ? t('{feature}: {n} now, {limit} on this plan.', { feature: featureLabel(t, i.key), n: i.in_use, limit: i.limit })
              : t('{feature}: {n} in use, not included in this plan.', { feature: featureLabel(t, i.key), n: i.in_use })}
          </li>
        ))}
      </ul>
    </div>
  );
}
